export default [
    {
        id: '1',
        text: 'questions.1.text',
        choices: [
            {
                type: 'yes',
                nextId: '2', 
            },
            {
                type: 'doubt',
                nextId: 'VVV',
            },
            {
                type: 'no',
                resultId: '1-1',
            },
        ],
    },
    {
        id: 'VVV',
        explanation: 'questions.VVV.explanation',
        statements: [
            {
                text: 'questions.VVV.statements.1.text',
                slider: { type: 'VVV', min: 1, max: 7 },
            },
            {
                text: 'questions.VVV.statements.2.text',
                slider: { type: 'VVV', min: 1, max: 7 },
            },
            {
                text: 'questions.VVV.statements.3.text',
                slider: { type: 'VVV', min: 1, max: 7, inverse: true },
            },
            {
                text: 'questions.VVV.statements.4.text',
                slider: { type: 'VVV', min: 1, max: 7 },
            },
        ],
        // Function to determine the answer (next target) from the given subanswers.
        determineAnswer(subanswers) {
            const score = subanswers.reduce((a, b) => a+ b, 0);

            if (score > 18) {
                return { nextId: '2' };
            }

            return { resultId: '1-2' };
        },
    },

    {
        id: '2',
        text: 'questions.2.text',
        choices: [
            {
                type: 'yes',
                nextId: '3',
            },
            {
                type: 'no',
                nextId: '2-A',
            },
        ],
    },
    {
        id: '2-A',
        text: 'questions.2-A.text',
        choices: [
            {
                type: 'yes',
                nextId: '2-A1',
            },
            {
                type: 'no',
                nextId: '2-B',
            },
        ],
    },
    {
        id: '2-A1',
        text: 'questions.2-A1.text',
        explanation: 'questions.2-A1.explanation',
        choices: [
            {
                type: 'yes',
                resultId: '2-A1',
            },
            {
                type: 'no',
                nextId: '2-A2',
            },
        ],
    },
    {
        id: '2-A2',
        text: 'questions.2-A2.text',
        choices: [
            {
                type: 'yes',
                resultId: '2-A2',
            },
            {
                type: 'no',
                nextId: '2', // TODO: Back to text 2?
            },
        ],
    },
    {
        id: '2-B',
        text: 'questions.2-B.text',
        explanation: 'questions.2-B.explanation',
        choices: [
            {
                type: 'yes',
                nextId: '2-B1',
            },
            {
                type: 'no',
                nextId: '2-C', // TODO: Unclear in Excel.
            },
        ],
    },
    {
        id: '2-B1',
        text: 'questions.2-B1.text',
        choices: [
            {
                type: 'yes',
                resultId: '2-B1',
            },
            {
                type: 'no',
                resultId: '2-B2',
            },
        ],
    },
    {
        id: '2-C',
        text: 'questions.2-C.text',
        explanation: 'questions.2-C.explanation',
        choices: [
            {
                type: 'yes',
                resultId: '2-C1',
            },
            {
                type: 'no',
                nextId: '2-D',
            },
        ],
    },
    {
        id: '2-D',
        text: 'questions.2-D.text',
        choices: [
            {
                type: 'yes',
                resultId: '2-D1',
            },
            {
                type: 'no',
                resultId: '2-D2',
            },
        ],
    },

    {
        id: '3',
        text: 'questions.3.text',
        choices: [
            {
                type: 'yes',
                nextId: '4', // TODO: Unclear in Excel.
            },
            {
                type: 'no',
                resultId: '3-1',
            },
        ],
    },
    {
        id: '4',
        text: 'questions.4.text',
        choices: [
            {
                type: 'yes',
                nextId: '4-A',
            },
            {
                type: 'no',
                nextId: '5',
            },
        ],
    },
    {
        id: '4-A',
        text: 'questions.4-A.text',
        explanation: 'questions.4-A.explanation',
        choices: [
            {
                type: 'yes',
                resultId: '4-1',
            },
            {
                type: 'no',
                nextId: '4-B',
            },
        ],
    },
    {
        id: '4-B',
        text: 'questions.4-B.text',
        choices: [
            {
                type: 'yes',
                resultId: '4-2',
            },
            {
                type: 'no',
                resultId: '4-3',
            },
        ],
    },

    {
        id: '5',
        text: 'questions.5.text',
        explanation: 'questions.5.explanation',
        choices: [
            {
                type: 'yes',
                nextId: '5-A',
            },
            {
                type: 'no',
                nextId: '6',
            },
        ],
    },
    {
        id: '5-A',
        text: 'questions.5-A.text',
        choices: [
            {
                type: 'yes',
                resultId: '5-1',
            },
            {
                type: 'no',
                resultId: '5-2',
            },
        ],
    },

    {
        id: '6',
        text: 'questions.6.text',
        explanation: 'questions.6.explanation',
        choices: [
            {
                type: 'yes',
                resultId: '6-1',
            },
            {
                type: 'no',
                nextId: '7',
            },
        ],
    },

    {
        id: '7',
        text: 'questions.7.text',
        choices: [
            {
                type: 'yes',
                nextId: '7-A',
            },
            {
                type: 'no',
                nextId: '8',
            },
        ],
    },
    {
        id: '7-A',
        subquestions: [
            {
                text: 'questions.7-A.subquestions.1.text',
                choices: [{ type: 'yes' }, { type: 'no' }],
            },
            {
                text: 'questions.7-A.subquestions.2.text',
                choices: [{ type: 'yes' }, { type: 'no' }],
            },
            {
                text: 'questions.7-A.subquestions.3.text',
                choices: [{ type: 'yes' }, { type: 'no' }],
            },
        ],
        // Function to determine the answer (next target) from the selected subanswers.
        determineAnswer(subanswers) {
            const yesCount = subanswers.filter(s => s.type === 'yes').length;

            if (yesCount >= 2) {
                return { resultId: '7-1A' };
            }

            return { resultId: '7-1B' };
        },
    },

    {
        id: '8',
        text: 'questions.8.text',
        explanation: 'questions.8.explanation',
        choices: [
            {
                type: 'yes',
                resultId: '8-1',
            },
            {
                type: 'no',
                nextId: 'SAL',
            },
        ],
    },
    {
        id: 'SAL',
        explanation: 'questions.SAL.explanation',
        statements: [
            {
                text: 'questions.SAL.statements.1.text',
                slider: { type: 'SAL', min: 0, max: 8 },
            },
            {
                text: 'questions.SAL.statements.2.text',
                explanation: 'questions.SAL.statements.2.explanation',
                slider: { type: 'SAL', min: 0, max: 8 },
            },
            {
                text: 'questions.SAL.statements.3.text',
                explanation: 'questions.SAL.statements.3.explanation',
                slider: { type: 'SAL', min: 0, max: 8 },
            },
            {
                text: 'questions.SAL.statements.4.text',
                explanation: 'questions.SAL.statements.4.explanation',
                slider: { type: 'SAL', min: 0, max: 8 },
            },
            {
                text: 'questions.SAL.statements.4.text',
                slider: { type: 'SAL', min: 0, max: 8 },
            },
        ],
        // Function to determine the answer (next target) from the given subanswers.
        determineAnswer(subanswers) {
            const score = subanswers.reduce((a, b) => a + b, 0);

            if (score > 20) { // TODO: Unclear in Excel.
                return { resultId: '8-3' };
            }

            return { resultId: '8-2' };
        },
    },
];
